import { render, staticRenderFns } from "./BlogGrid.vue?vue&type=template&id=6460fbc2"
import script from "./BlogGrid.vue?vue&type=script&lang=js"
export * from "./BlogGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports